import { render, staticRenderFns } from "./seatsToSuitChanges.vue?vue&type=template&id=1525106a&scoped=true&"
import script from "./seatsToSuitChanges.vue?vue&type=script&lang=js&"
export * from "./seatsToSuitChanges.vue?vue&type=script&lang=js&"
import style0 from "./seatsToSuitChanges.vue?vue&type=style&index=0&id=1525106a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1525106a",
  null
  
)

export default component.exports